var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCenterLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1025,
    height: 2703,
    viewBox: "0 0 1025 2703",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.927 15.0618C491.593 37.7409 511.004 103.606 551.514 193.496C602.151 305.859 541.213 502.331 494.927 637.895C448.64 773.459 492.068 1101.89 514.247 1363.19C582.841 2171.35 77.3755 2493.57 66.6753 2611.62",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.927 15.0618C491.593 37.7409 511.004 103.606 551.514 193.496C602.151 305.859 541.213 502.331 494.927 637.895C448.64 773.459 492.068 1101.89 514.247 1363.19C582.841 2171.35 77.3755 2493.57 66.6753 2611.62",
    stroke: "url(#paint0_linear_263_5)",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.539 8.70194C516.322 30.4334 517.517 97.2448 564.029 190.638C622.169 307.38 579.338 500.221 515.192 626.56C451.046 752.899 267.128 1400.55 532.246 1631.2C993.746 2032.7 86.0787 2500.67 67.2461 2614.7",
    stroke: "black",
    strokeWidth: 2.27364
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_5",
    x1: 446.905,
    y1: 5.19078,
    x2: 1111.13,
    y2: 90.5185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664583,
    stopColor: "#55F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A659F3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterLines);
export default __webpack_public_path__ + "static/media/centerLines.5e75d914a8279215eba3402ba5257fa5.svg";
export { ForwardRef as ReactComponent };